import { Box } from '@resideo/blueprint-react';
import React, { FC } from 'react';

interface SpaceType {
  size?: number | string;
}

const Space: FC<SpaceType> = ({ size = 16 }) => <Box height={size} />;

export default Space;
